import { SourceType } from 'module/api/filter/types';
import { asUserMetaData } from 'module/helpers/filter/as-user-field-meta';
import { useTranslation } from 'module/hooks/use-translation';
import { FieldType } from 'module/types/filter-field/field/field';
import { MultiUserField } from 'module/types/filter-field/field/filterable-field';
import { useGetAllActiveExternalUsersQuery } from 'queries/member';
import { useMemo } from 'react';

export const useChampionsField = (
  fieldId: number,
): {
  field: MultiUserField;
  isLoading: boolean;
} => {
  const { data: customerUsers, isLoading: isUserLoading } =
    useGetAllActiveExternalUsersQuery();
  const fieldLabel = useTranslation('company.fields.champions');

  return useMemo(
    () => ({
      field: {
        fieldId,
        fieldName: 'champions',
        fieldLabel,
        type: FieldType.MultiUser,
        private: false,
        userCreated: false,
        metaData: asUserMetaData(customerUsers ?? []),
        sourceType: SourceType.Company,
      },
      isLoading: isUserLoading,
    }),
    [fieldId, fieldLabel, customerUsers, isUserLoading],
  );
};
